import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss'],
})
export class CounterComponent implements OnInit {
  @Input()
  public label: string = `label`;
  @Input()
  public value: number = 0;

  constructor() {}

  ngOnInit(): void {}
}
